<template>
  <button class="btn btn-outline-first btn-back btn-rounded text-nowrap d-none d-md-flex align-items-center mb-3" @click="stepAction">
    <TyIcon icon="ty-arrow-left" width=".7rem" class="pointer"/>
    <span>{{ $t('step-back-button') }}</span>
  </button>
</template>

<script setup lang="ts">

import {useRouter} from "#app";

const props = defineProps({
  backAction: Function | undefined
})

const stepAction = () => {
  if (props.backAction !== undefined) {
    props.backAction();
  } else {
    useRouter().back()
  }
}
</script>
